import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';
import { morph } from '@theme/morph';

class MrPoetikStockStatus extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.closest('.shopify-section, dialog')?.addEventListener(StandardEvents.productSelect, this.handleProductSelect);
  }

  disconnectedCallback() {
    this.closest('.shopify-section, dialog')?.removeEventListener(StandardEvents.productSelect, this.handleProductSelect);
  }

  handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    event.promise.then(({ detail }) => {
      if (!detail?.html) return;
      const replacement = detail.html.querySelector('mrpoetik-stock-status');
      if (replacement) morph(this, replacement, { childrenOnly: true });
    }).catch((error) => {
      if (error?.name !== 'AbortError') console.warn('[mrpoetik-stock-status] Variant update failed:', error);
    });
  };
}

if (!customElements.get('mrpoetik-stock-status')) customElements.define('mrpoetik-stock-status', MrPoetikStockStatus);
